import apiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { Data } from '../signup-data/DATA';
import { getHublet } from '../store/app/selectors';
import { getGoogleContactsSyncConnectionId, getPortalId } from '../store/auth/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { getGoogleContactsAppId } from './googleContactsSyncUtils';
export const createConnection = state => {
  const hublet = getHublet(state);
  const portalId = getPortalId(state);
  const appId = getGoogleContactsAppId();
  const accountId = getSignupDataValue(state, Data.GoogleAccountId);
  return apiClient.post(`${getFullUrl('app-api', {
    hubletOverride: hublet
  })}/sync-bridge/v3/accounts/${accountId}/connection?portalId=${portalId}&appId=${appId}`, {
    data: {
      objectTypes: {
        hubSpotObjectTypeId: '0-1',
        remote: 'contacts'
      }
    }
  });
};
export const saveConnection = state => {
  const hublet = getHublet(state);
  const portalId = getPortalId(state);
  const appId = getGoogleContactsAppId();
  const connectionId = getGoogleContactsSyncConnectionId(state);
  return apiClient.put(`${getFullUrl('app-api', {
    hubletOverride: hublet
  })}/sync-bridge/v3/connections/${connectionId}?portalId=${portalId}&appId=${appId}`, {
    data: {
      conflictResolution: 'DEFAULT_TO_HUBSPOT',
      rules: {
        direction: 'INBOUND',
        filters: {},
        updateOnlyDirection: 'NONE'
      },
      matchingFilter: {
        name: 'email_only',
        value: true
      },
      defaultValueDatasetParameters: []
    }
  });
};
export const activateSync = state => {
  const hublet = getHublet(state);
  const portalId = getPortalId(state);
  const appId = getGoogleContactsAppId();
  const connectionId = getGoogleContactsSyncConnectionId(state);
  return apiClient.post(`${getFullUrl('app-api', {
    hubletOverride: hublet
  })}/sync-bridge/v3/connections/${connectionId}/activate?portalId=${portalId}&appId=${appId}`);
};